import { render, staticRenderFns } from "./MealAdd.vue?vue&type=template&id=410534fe&scoped=true&"
import script from "./MealAdd.vue?vue&type=script&lang=js&"
export * from "./MealAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410534fe",
  null
  
)

export default component.exports